import { ofType } from 'redux-observable';
import { switchMap } from 'rxjs/operators/switchMap';
import { tap } from 'rxjs/operators/tap';

import { forkEpic } from '../../utils/epics/forkEpic';
import areaExpandEpic from './areaExpand';

import { types as actions, areaExpandAction } from '../../reducers/actions';

export default function(action$, store) {
  return action$.pipe(
    ofType(actions.SET_CURRENT_AREA),
    tap(
      action =>
        action.save &&
        action.area &&
        localStorage.setItem(`airfinder_selected_area`, action.area.id)
    ),
    switchMap(action =>
      forkEpic(areaExpandEpic, store, areaExpandAction(action.area, action.ignoreFile))
    )
  );
}



// WEBPACK FOOTER //
// ./src/epics/areas/setCurrentArea.js